"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUploadedProfileImageDto = instanceOfUploadedProfileImageDto;
exports.UploadedProfileImageDtoFromJSON = UploadedProfileImageDtoFromJSON;
exports.UploadedProfileImageDtoFromJSONTyped = UploadedProfileImageDtoFromJSONTyped;
exports.UploadedProfileImageDtoToJSON = UploadedProfileImageDtoToJSON;
exports.UploadedProfileImageDtoToJSONTyped = UploadedProfileImageDtoToJSONTyped;
/**
 * Check if a given object implements the UploadedProfileImageDto interface.
 */
function instanceOfUploadedProfileImageDto(value) {
    if (!('fileUrl' in value) || value['fileUrl'] === undefined)
        return false;
    return true;
}
function UploadedProfileImageDtoFromJSON(json) {
    return UploadedProfileImageDtoFromJSONTyped(json, false);
}
function UploadedProfileImageDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileUrl': json['fileUrl'],
    };
}
function UploadedProfileImageDtoToJSON(json) {
    return UploadedProfileImageDtoToJSONTyped(json, false);
}
function UploadedProfileImageDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'fileUrl': value['fileUrl'],
    };
}
